import { render } from "./PersonUpload.vue?vue&type=template&id=1b72e059"
import script from "./PersonUpload.vue?vue&type=script&lang=js"
export * from "./PersonUpload.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__